import { CreativeType } from 'types';

export const creativeAcceptMediaTypes = 'image/*, video/*';

export const getDimensions = (width: number, height: number) => `${width}x${height}`;

export const isMediaSizeValid = (file: File, limit: number) => file.size <= limit;

export const getImageDimensions = (file: File) => {
  return new Promise<string>((resolve) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        resolve(getDimensions(width, height));
      };

      img.src = e?.target?.result as string;
    };

    reader.readAsDataURL(file);
  });
};

export const getVideoDimensions = (file: File) => {
  return new Promise<string>((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);

      const width = video.videoWidth;
      const height = video.videoHeight;

      resolve(getDimensions(width, height));
    };
    video.src = url;
  });
};

const noPreviewMedia = ['avi', 'x-msvideo'];
const noPreviewExtension = ['.avi'];

export const isNoPrevoiewByMediaType = (type: string) => noPreviewMedia.some((media) => type.includes(media));

export const isNoPreviewByOriginalFileName = (fileName: string) =>
  noPreviewExtension.some((extension) => fileName.endsWith(extension));

export const getMatchingCreativeTypes = async (creativeFile: File, creativeTypes: CreativeType[]) => {
  if (!creativeFile) return creativeTypes;

  const isImage = creativeFile?.type?.includes('image');
  const fileDimensions = isImage ? await getImageDimensions(creativeFile) : await getVideoDimensions(creativeFile);
  const fileSize = creativeFile.size;

  return creativeTypes.filter((creativeType) => {
    const isSameDimensions = getDimensions(creativeType.width, creativeType.height) === fileDimensions;

    if (isSameDimensions) {
      return fileSize <= creativeType.maxFileSizeBytes;
    } else {
      return false;
    }
  });
};

export const getCreativeFormat = async (file: File, creativeTypes: CreativeType[]) => {
  const isImage = file?.type?.includes('image');
  const isVideo = file?.type?.includes('video');

  if (!isImage && !isVideo) {
    return null;
  }

  if (isNoPrevoiewByMediaType(file.type))
    return creativeTypes.find((creativeType) => creativeType.mediaType === 'video');

  const matchingCreativeTypes = await getMatchingCreativeTypes(file, creativeTypes);

  if (matchingCreativeTypes.length === 0) {
    return null;
  }
  // current implementation require us to choose only one creativeType per creative, so let's take first matching
  // in CreativeUploadDialog user will have a chance to change it
  return matchingCreativeTypes[0] ?? null;
};
